// AI 气泡 markdown 渲染入口（浏览器/bundler 使用）。
// html:false —— 原始 HTML 标签一律转义为纯文本（对齐小程序侧不解析 HTML 的约定）；
// breaks:true —— 单换行转 <br>；linkify:true —— 裸 URL 自动成链。
// 流式期间每次全量重渲染，未闭合语法由 markdown-it 自然容错（如未闭合代码块渲染到文末）。
import MarkdownIt from "markdown-it";
import { applyAiMarkdownExtensions } from "./aiMarkdownCore.js";

const md = new MarkdownIt({
  html: false,
  breaks: true,
  linkify: true,
});
applyAiMarkdownExtensions(md);

export function renderAiMarkdown(text) {
  return md.render(String(text == null ? "" : text));
}

export default {
  renderAiMarkdown,
};
